import Vue from 'vue';
import { mutations } from './channel.d';

export default {
  /**
   * Initialize own channel list
   */
  [mutations.setOwnChannels](state, channels) {
    state.ownChannels = channels;
  },

  [mutations.setCurrentChannel](state, channel) {
    state.currentChannel = channel;
  },

  [mutations.setCurrentChannelStatus](state, status) {
    state.currentChannel.status = status;
  },

  [mutations.updateCurrentChannel](state, payload) {
    state.currentChannel[payload.key] = payload.value;
  },

  [mutations.setChannelUnread](state, payload) {
    const { channelUrl, isUnread } = payload;
    if (isUnread === false) {
      Vue.delete(state.unreadChannels, channelUrl);
      return;
    }
    Vue.set(state.unreadChannels, channelUrl, true);
  }
};
